module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_11.34250fd9.jpg";